/* Faan Perfumes — live activity popup ("salespop"). Real purchases (FragranceGems
   orders of the same FAAN bottles, marked "via FragranceGems", plus orders on this
   shop as they come), real add-to-carts and real 4-5 star FragranceGems SHOP reviews
   from faan-salespop.fragrance-gems.workers.dev. Nothing here invents an entry.
   Deferred: work starts after load / first interaction, fixed overlay, so no CLS.

   Third instance of the FragranceGems / Mykonos popup (areas/fg-salespop.md,
   areas/faan-salespop.md). Own Worker, own D1, own theme asset.

   This file is the SOURCE: Shopify minifies theme JS on its own CDN, so comments cost
   the visitor nothing. DO NOT pre-minify. */
(function () {
  'use strict';

  var API = 'https://faan-salespop.fragrance-gems.workers.dev';

  var LANG = (document.documentElement.lang || 'en').slice(0, 2).toLowerCase();
  if (LANG !== 'nl' && LANG !== 'de') LANG = 'en';
  var T = {
    en: { hide: 'Hide these', close: 'Close', via: 'via' },
    nl: { hide: 'Verbergen', close: 'Sluiten', via: 'via' },
    de: { hide: 'Ausblenden', close: 'Schließen', via: 'über' }
  }[LANG];

  /* Cadence per viewport. Desktop: an empty bottom-left corner, so it can come round
     often. Phone: it covers real estate, so it stays rarer. Same 749px breakpoint as
     the theme. */
  var PHONE = matchMedia('(max-width: 749px)');
  var GAP = { phone: [25000, 60000], desktop: [7000, 14000] };
  var FIRST_GAP = { phone: [8000, 15000], desktop: [3000, 7000] };
  var VISIBLE_MS = 5000;
  var RECHECK_MS = 2000;
  /* The same bottle is announced at most this often to one visitor per tab session. */
  var MAX_PER_PRODUCT = 2;
  var HIDE_KEY = 'fa_sp_off';
  var SEEN_KEY = 'fa_sp_seen';
  var ATTR_KEY = 'fa_sp_attr';
  /* 0 = "Hide these" is always visible; an opt-out nobody can find is not one. */
  var HIDE_AFTER_DISMISSALS = 0;

  /* The quick view / review / store panel lives in its own asset, fetched only when a
     shopper clicks a toast. Its URL comes from Liquid (data-qv): asset_url always
     carries Shopify's current content hash, so no hand-kept ?v= can go stale. */
  var QV_SRC = (document.currentScript && document.currentScript.dataset.qv) || '';

  /* Never on cart or checkout. */
  var main = document.getElementById('MainContent');
  var template = (main && main.dataset.template) || '';
  if (/cart|checkout/.test(template) || /\/(cart|checkouts?)(\/|$)/.test(location.pathname)) return;

  var reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* Per page load only: no cookie, no visitor id. */
  var pageId = Math.random().toString(36).slice(2, 12);

  function readStore(store, key, fallback) {
    try { return JSON.parse(window[store].getItem(key)) || fallback; }
    catch (e) { return fallback; }
  }
  function writeStore(store, key, value) {
    try { window[store].setItem(key, JSON.stringify(value)); } catch (e) { /* private mode */ }
  }

  if (readStore('localStorage', HIDE_KEY, false)) return;

  var seen = readStore('sessionStorage', SEEN_KEY, {});
  function timesShown(id) { return seen[id] || 0; }
  function noteShown(id) {
    seen[id] = timesShown(id) + 1;
    writeStore('sessionStorage', SEEN_KEY, seen);
  }
  /* Anything with its own id is a REVIEW (cap 1: the same words twice read as a broken
     loop); everything else is capped per product. */
  function keyOf(e) { return e.id ? 'r' + e.id : String(e.product_id || ''); }
  function capOf(e) { return e.id ? 1 : MAX_PER_PRODUCT; }
  function overExposed(e) { return timesShown(keyOf(e)) >= capOf(e); }

  /* ------------------------------------------------------------------ lock */

  /* One-directional mutex: we respect other popups and publish ours. */
  var OTHERS = [
    /* Shopify consent banner: fixed, z-index 2000000, bottom centre (measured at
       1440x900: x360-1080 / y690-900, and at 390x844 it fills most of the screen). A
       toast under it would be painted over, so we wait until it is answered. */
    '#shopify-pc__banner',
    /* Judge.me corner popup, if that block is ever switched on. */
    '.jdgm-popup-widget', '.jdgm-popup',
    /* Every Horizon overlay is a native <dialog>: cart drawer, search, chat drawer. */
    'dialog[open]',
    /* Faan's own mobile menu drawer (visibility:hidden while closed). */
    '.f-drawer.is-open', '.f-drawer[aria-hidden="false"]'
  ];

  function onScreen(el) {
    if (!el) return false;
    var cs = getComputedStyle(el);
    if (cs.display === 'none' || cs.visibility === 'hidden' || parseFloat(cs.opacity) === 0) return false;
    var r = el.getBoundingClientRect();
    return r.width > 0 && r.height > 0 && r.bottom > 0 && r.top < innerHeight;
  }

  var lock = window.__faPopupLock = window.__faPopupLock || {
    owner: null,
    busy: function () {
      if (lock.owner) return true;
      for (var i = 0; i < OTHERS.length; i++) {
        if (onScreen(document.querySelector(OTHERS[i]))) return true;
      }
      return false;
    },
    acquire: function (name) {
      if (lock.busy()) return false;
      lock.owner = name;
      return true;
    },
    release: function (name) {
      if (lock.owner === name) lock.owner = null;
    }
  };

  /* --------------------------------------------------------------- styling */

  /* Faan palette (assets/faan.css tokens, with their literal values as fallback):
     card #fbf7f0 on the #f5eee2 page, ink #1d1813, gold #b38a45 hairline, gold text
     #7d5c25 (AA on the card), Playfair Display for names, Jost for everything else.
     Every corner radius in this theme is 0. */
  var CSS =
    '.fa-sp{position:fixed;left:16px;bottom:calc(16px + var(--fa-sp-lift,0px) + env(safe-area-inset-bottom,0px));' +
    'z-index:1000000;width:min(340px,calc(100vw - 32px));display:flex;gap:12px;align-items:center;' +
    /* A floor, not a fixed height: the kicker may wrap to two lines ("Someone in the
       Netherlands added to cart"), and align-items:center spreads the slack so every
       card type has the same height. */
    'box-sizing:border-box;min-height:104px;' +
    'padding:10px;padding-inline-end:6px;border:1px solid var(--f-line2,rgba(179,138,69,.5));' +
    'background:var(--f-bg2,#fbf7f0);box-shadow:0 10px 30px rgba(70,45,10,.18);' +
    'font:400 14px/1.35 var(--f-sans,Jost,sans-serif);color:var(--f-ink,#1d1813);text-align:left;' +
    'opacity:0;transform:translateY(12px);transition:opacity .28s ease,transform .28s ease;' +
    'contain:layout paint}' +
    /* pointer-events stay ON through the fade-out: a click in those 280ms must not
       silently do nothing. */
    '.fa-sp{pointer-events:auto}' +
    '.fa-sp[data-show="1"]{opacity:1;transform:none}' +
    '.fa-sp:not([data-show="1"]){pointer-events:none}' +
    '.fa-sp__img{width:56px;height:56px;flex:0 0 auto;object-fit:contain;background:#fff;' +
    'border:1px solid var(--f-line,rgba(179,138,69,.28))}' +
    '.fa-sp__b{min-width:0;flex:1 1 auto}' +
    '.fa-sp__k{display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;' +
    'font-size:12px;line-height:1.3;color:var(--f-mute,rgba(29,24,19,.66));margin-bottom:2px}' +
    '.fa-sp__t{display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;' +
    'font:500 14.5px/1.3 var(--f-serif,"Playfair Display",serif);color:var(--f-ink,#1d1813)}' +
    /* Review cards: kicker = name + stars, main line = the quote, meta = the source. */
    '.fa-sp[data-type$="review"] .fa-sp__t{font:400 13.5px/1.35 var(--f-sans,Jost,sans-serif);font-style:italic}' +
    /* The shop mark is a square gold glyph: letter it in, never crop it. */
    '.fa-sp[data-type="store_review"] .fa-sp__img{padding:6px;box-sizing:border-box}' +
    '.fa-sp__s{letter-spacing:1px;font-size:12px;color:var(--f-gold-t,#7d5c25)}' +
    '.fa-sp__m{display:block;min-width:0;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;' +
    'font-size:11.5px;color:var(--f-mute,rgba(29,24,19,.66))}' +
    /* The source label ("FragranceGems store review · Verified customer") is the one
       meta line that is long: let it take two lines instead of cutting "Verified". */
    '.fa-sp[data-type$="review"] .fa-sp__m{display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;white-space:normal;line-height:1.3}' +
    /* position:relative is load-bearing: .fa-sp__l is an absolutely positioned overlay
       over the whole card and would swallow clicks meant for Hide and the close x. */
    '.fa-sp__h{position:relative;z-index:1;flex:0 0 auto;border:0;background:none;padding:0 0 0 8px;' +
    'margin-left:6px;font:inherit;font-size:11.5px;color:var(--f-gold-t,#7d5c25);text-decoration:underline;' +
    'cursor:pointer;border-left:1px solid var(--f-line,rgba(179,138,69,.28))}' +
    '.fa-sp__h:hover{color:var(--f-ink,#1d1813)}' +
    '.fa-sp__meta-row{display:flex;align-items:baseline;min-width:0;margin-top:2px}' +
    '.fa-sp__x{position:relative;z-index:1;flex:0 0 auto;align-self:flex-start;width:44px;height:44px;' +
    'margin:-6px -2px 0 0;border:0;background:none;color:var(--f-mute,rgba(29,24,19,.66));font-size:18px;' +
    'line-height:1;cursor:pointer}' +
    '.fa-sp__x:hover{color:var(--f-ink,#1d1813)}' +
    '.fa-sp__l{position:absolute;inset:0}' +
    '.fa-sp__l:focus-visible,.fa-sp__x:focus-visible,.fa-sp__h:focus-visible{outline:2px solid var(--f-gold-l,#dcc08a);outline-offset:2px}' +
    '@media (min-width: 750px){' +
    '.fa-sp{width:420px;left:20px;bottom:calc(20px + var(--fa-sp-lift,0px));min-height:128px;' +
    'gap:14px;padding:12px;padding-inline-end:8px}' +
    '.fa-sp__img{width:72px;height:72px}' +
    '.fa-sp__k{font-size:13px}' +
    '.fa-sp__t{font-size:16px}' +
    '.fa-sp[data-type$="review"] .fa-sp__t{font-size:14.5px}' +
    '.fa-sp__m,.fa-sp__h{font-size:12.5px}' +
    '}' +
    '@media (prefers-reduced-motion: reduce){.fa-sp{transition-duration:.01ms;transform:none}}';

  /* --------------------------------------------------------------- helpers */

  /* "3 minutes ago" / "vor 3 Minuten" / "3 minuten geleden", from the browser itself. */
  function ago(sec) {
    var m = Math.max(1, Math.round(sec / 60));
    var u = 'minute', n = m;
    if (m >= 60) { n = Math.round(m / 60); u = 'hour'; }
    if (n >= 24 && u === 'hour') { n = Math.round(n / 24); u = 'day'; }
    try { return new Intl.RelativeTimeFormat(LANG, { numeric: 'auto' }).format(-n, u); }
    catch (e) { return n + ' ' + u; }
  }

  function track(kind, entry) {
    try {
      var body = JSON.stringify({
        kind: kind,
        entry_type: entry ? entry.type : null,
        product_id: entry ? entry.product_id : null,
        page_id: pageId
      });
      navigator.sendBeacon(API + '/events/track', new Blob([body], { type: 'text/plain' }));
    } catch (e) { /* tracking must never break the page */ }
  }

  /* Conversion attribution: written ONLY once a cart already exists, and only for the
     first card of the session, exactly once. */
  var attrsWritten = false;

  function cartExists() {
    var b = document.querySelector('.cart-bubble__text-count');
    return !!(b && parseInt(b.textContent, 10) > 0);
  }

  function writeAttrs(attrs) {
    if (attrsWritten) return;
    var saved = readStore('sessionStorage', ATTR_KEY, null);
    if (saved === 1) { attrsWritten = true; return; }
    if (!saved) saved = attrs;
    if (!saved) return;
    writeStore('sessionStorage', ATTR_KEY, saved);
    if (!cartExists()) return;
    attrsWritten = true;
    writeStore('sessionStorage', ATTR_KEY, 1);
    fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: saved }),
      keepalive: true
    }).catch(function () {
      attrsWritten = false;
      writeStore('sessionStorage', ATTR_KEY, saved);
    });
  }

  window.__faSalespopFlush = function () { writeAttrs(null); };
  /* The quick-view asset reports its own add-to-carts through here. */
  window.__faSalespopTrack = track;

  /* ------------------------------------------------------------------ view */

  var el = null, hideTimer = null, current = null, stopped = false, dismissals = 0;

  function build() {
    var s = document.createElement('style');
    s.textContent = CSS;
    document.head.appendChild(s);

    el = document.createElement('aside');
    el.className = 'fa-sp';
    /* Out of the accessibility tree on purpose: an aria-live sales toast every few
       seconds is an interruption, not information. Everything it links to is reachable
       by normal browsing. */
    el.setAttribute('aria-hidden', 'true');
    el.innerHTML =
      '<a class="fa-sp__l" href="#" aria-hidden="true" tabindex="-1"></a>' +
      '<img class="fa-sp__img" alt="" width="56" height="56" loading="lazy" decoding="async">' +
      '<div class="fa-sp__b">' +
      '<span class="fa-sp__k"></span><span class="fa-sp__t"></span>' +
      '<span class="fa-sp__meta-row"><span class="fa-sp__m"></span>' +
      '<button class="fa-sp__h" type="button" hidden></button></span></div>' +
      '<button class="fa-sp__x" type="button">×</button>';
    el.querySelector('.fa-sp__h').textContent = T.hide;
    el.querySelector('.fa-sp__x').setAttribute('aria-label', T.close);
    el.style.position = 'fixed';
    document.body.appendChild(el);

    /* Hovering holds the card open; leaving restarts the clock. */
    el.addEventListener('mouseenter', function () { clearTimeout(hideTimer); });
    el.addEventListener('mouseleave', function () {
      if (el.dataset.show === '1') hideTimer = setTimeout(hide, 1200);
    });

    el.querySelector('.fa-sp__x').addEventListener('click', function (ev) {
      ev.preventDefault();
      ev.stopPropagation();
      track('dismiss', current);
      dismissals++;
      hide();
    });
    el.querySelector('.fa-sp__h').addEventListener('click', function (ev) {
      ev.preventDefault();
      ev.stopPropagation();
      track('hide', current);
      writeStore('localStorage', HIDE_KEY, true);
      hide();
      if (el.parentNode) el.parentNode.removeChild(el);
      stopped = true;
    });
    el.querySelector('.fa-sp__l').addEventListener('click', function (ev) {
      if (!current) return;
      ev.preventDefault();
      track('click', current);
      var e = current;
      hide();
      openOverlay(e);
    });
  }

  var qvLoading = false;

  /* Everything opens in place: a store review opens the panel, a review its lightbox,
     a bought / added-to-cart card the product. Product title, image and link are always
     the FAAN product on THIS shop (the Worker stores ours, never FragranceGems'). */
  function openOverlay(e) {
    var fn = e.type === 'store_review' ? '__faStoreView'
      : e.body ? '__faReviewView' : '__faQuickView';
    var arg = e.body ? e.id : e.handle;
    var fallback = function () {
      location.href = root + (e.handle ? 'products/' + e.handle : 'pages/about');
    };
    if (!arg) return fallback();
    if (window[fn]) return window[fn](arg);
    if (qvLoading || !QV_SRC) return fallback();
    qvLoading = true;
    var sc = document.createElement('script');
    sc.src = QV_SRC;
    sc.onload = function () {
      qvLoading = false;
      if (window[fn]) window[fn](arg); else fallback();
    };
    sc.onerror = function () { qvLoading = false; fallback(); };
    document.head.appendChild(sc);
  }

  /* Lift above any bottom bar (none on Faan today; measured rather than hard-coded so
     a future one is handled). */
  function lift() {
    var most = 0;
    var bars = document.querySelectorAll('.sticky-add-to-cart__bar');
    for (var i = 0; i < bars.length; i++) {
      var b = bars[i];
      if (!onScreen(b)) continue;
      var r = b.getBoundingClientRect();
      if (r.bottom >= innerHeight - 4) most = Math.max(most, r.height + 8);
    }
    el.style.setProperty('--fa-sp-lift', most + 'px');
  }

  /* One component, the three text slots and the image change. Purchase / cart-add:
     kicker (built and localised by the Worker) / product / how long ago + "via". Review
     and store review: "Name ★★★★★" / the quote / the source label. The branch is on
     whether the entry HAS a quote. */
  function render(e, now) {
    el.dataset.type = e.type;
    var img = el.querySelector('.fa-sp__img');
    /* A store review carries the FragranceGems mark, never the customer's photo (that
       leads the panel behind the click). */
    img.src = (e.type === 'store_review' ? '' : e.photo) || e.image;
    img.alt = e.title;
    var k = el.querySelector('.fa-sp__k');

    if (e.body) {
      k.textContent = e.reviewer ? e.reviewer + ' ' : '';
      var stars = document.createElement('span');
      stars.className = 'fa-sp__s';
      stars.textContent = '★'.repeat(e.rating || 5);
      k.appendChild(stars);
      el.querySelector('.fa-sp__t').textContent = '“' + e.body + '”';
      el.querySelector('.fa-sp__m').textContent = e.title;
    } else {
      k.textContent = e.kick || '';
      el.querySelector('.fa-sp__t').textContent = e.title;
      /* Most purchases happened on FragranceGems, the sister shop that sells the same
         bottles: the card says so, so it never reads as an order placed here. Guarded:
         an order on this shop arrives with no `via`. */
      el.querySelector('.fa-sp__m').textContent = ago(Math.max(0, now - e.ts)) +
        (e.via ? ' · ' + T.via + ' ' + e.via : '');
    }
    /* Never '#': the overlay is a real link, so a middle-click or a failed asset load
       lands on the right Faan page. */
    el.querySelector('.fa-sp__l').href =
      root + (e.handle ? 'products/' + e.handle : 'pages/about');
  }

  function show(e, now) {
    if (!lock.acquire('salespop')) return false;
    current = e;
    render(e, now);
    lift();
    el.querySelector('.fa-sp__h').hidden = dismissals < HIDE_AFTER_DISMISSALS;
    el.dataset.show = '1';
    noteShown(keyOf(e));
    track('impression', e);
    writeAttrs({
      _salespop_seen: '1',
      _salespop_type: e.type,
      _salespop_product: String(e.product_id || '')
    });
    hideTimer = setTimeout(hide, VISIBLE_MS + (reduced ? 0 : 280));
    return true;
  }

  function hide() {
    clearTimeout(hideTimer);
    el.dataset.show = '0';
    current = null;
    lock.release('salespop');
  }

  /* ------------------------------------------------------------- cart-adds */

  /* NOT a fetch/XHR patch. Click/submit listener, then poll /cart.js and report only the
     line that really appeared: may under-count, can never invent an add. Only the
     product ID is sent; the Worker looks title and brand up itself (the browser's title
     is translated to the shopper's locale). */
  var ADDERS = '[name="add"],.add-to-cart-button,.quick-add__button';
  var polling = false;

  function readCart() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .catch(function () { return null; });
  }
  function lineKey(i) { return i.key || i.variant_id || i.id; }
  function qtyMap(c) {
    var m = {};
    if (c && c.items) for (var i = 0; i < c.items.length; i++) m[lineKey(c.items[i])] = c.items[i].quantity;
    return m;
  }
  function beaconAdds(before, after) {
    var sent = 0;
    for (var i = 0; i < after.items.length; i++) {
      var it = after.items[i];
      if ((before[lineKey(it)] || 0) >= it.quantity) continue;
      try {
        navigator.sendBeacon(API + '/events/cart-add', new Blob([JSON.stringify({
          product_id: String(it.product_id || '')
        })], { type: 'text/plain' }));
        sent++;
      } catch (err) { /* a beacon must never break add-to-cart */ }
    }
    return sent;
  }
  function watchCart() {
    if (polling) return;
    polling = true;
    readCart().then(function (before) {
      if (!before) { polling = false; return; }
      var was = qtyMap(before), tries = 0;
      (function again() {
        setTimeout(function () {
          readCart().then(function (after) {
            if (after && after.items && beaconAdds(was, after)) {
              polling = false;
              window.__faSalespopFlush();
              return;
            }
            if (++tries < 8) again(); else polling = false;
          });
        }, 350);
      })();
    });
  }
  addEventListener('click', function (ev) {
    var t = ev.target;
    if (t && t.closest && t.closest(ADDERS)) watchCart();
  }, true);
  addEventListener('submit', function (ev) {
    var f = ev.target;
    if (f && f.action && f.action.indexOf('/cart/add') > -1) watchCart();
  }, true);

  /* ------------------------------------------------------------------ loop */

  var queue = [], drift = 0;

  function fetchFeed() {
    /* 20, not 12: the per-product cap filters this list, and a short feed can filter
       down to almost nothing. `lang` comes from the page's own lang attribute, not the
       domain, so reviews and copy follow the language the shopper is reading. */
    var u = API + '/popup/feed?limit=20&lang=' + LANG;
    var pid = productIdOnPage();
    if (pid) u += '&product_id=' + pid;
    return fetch(u, { credentials: 'omit' })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        queue = (d.entries || []).filter(function (e) { return !overExposed(e); });
        drift = d.now - Math.floor(Date.now() / 1000);
      })
      .catch(function () { queue = []; });
  }

  /* The buy form is authoritative: cards also carry a [data-product-id]. */
  function productIdOnPage() {
    var i = document.querySelector('#MainContent input[name="product-id"], #MainContent input[name="product_id"]');
    if (i && /^\d+$/.test(i.value)) return i.value;
    return null;
  }

  function gap(first) {
    var table = first ? FIRST_GAP : GAP;
    var g = PHONE.matches ? table.phone : table.desktop;
    return g[0] + Math.random() * (g[1] - g[0]);
  }

  function tick() {
    if (stopped) return;
    if (document.hidden) return setTimeout(tick, RECHECK_MS);
    while (queue.length && overExposed(queue[0])) queue.shift();
    if (!queue.length) {
      return fetchFeed().then(function () {
        setTimeout(tick, queue.length ? gap() : 5 * 60000);
      });
    }
    var e = queue.shift();
    var ok = show(e, Math.floor(Date.now() / 1000) + drift);
    if (!ok) {
      // Another popup owns the screen: put it back and retry. Never stack.
      queue.unshift(e);
      return setTimeout(tick, RECHECK_MS);
    }
    setTimeout(tick, gap());
  }

  function start() {
    if (el) return;
    build();
    fetchFeed().then(function () {
      if (queue.length) setTimeout(tick, gap(true));
    });
  }

  function arm() {
    ['scroll', 'touchstart', 'mousemove', 'keydown'].forEach(function (t) {
      addEventListener(t, once, { passive: true, once: true });
    });
    if (document.readyState === 'complete') setTimeout(start, 0);
    else addEventListener('load', once, { once: true });
  }
  function once() { start(); }

  arm();
})();
